import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReturnSaveStepComponent } from './return-save-step.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { FormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { PosTotalsModule } from 'src/app/shared/pos-totals/pos-totals.module';



@NgModule({
  declarations: [ReturnSaveStepComponent],
  imports: [
    CommonModule,
    AccordionModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    PosTableModule,
    PosTotalsModule
  ],
  exports: [ReturnSaveStepComponent]
})
export class ReturnSaveStepModule { }
